import { render, staticRenderFns } from "./employeeDetail.vue?vue&type=template&id=8c1430d8"
import script from "./employeeDetail.vue?vue&type=script&lang=js"
export * from "./employeeDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports